import React, { useState } from "react";
import "./FindRoles.css";

export default function FindRoles() {
  const [active, setActive] = useState(null);

const traits = [
  "Dentist",
  "Endodontist",
  "Orthodontist",
  "Implantologist",
  "Dental Assistant",
  "Chairside Assistant",
  "Front Desk Executive",
  "Patient Coordinator",
  "Billing Executive",
  "Clinic Manager",
  "Social Media Manager",
  "Content Creator",
  "HR Coordinator",
  "Housekeeping Staff"
];


  return (
    <section className="roles-section">

      {/* ---------- TOP CARDS ---------- */}
      <div className="roles-cards">
        <div className="role-card purple">
          <h3>Application</h3>
          <p>Fill the form & upload your google-drive link of your resume/portfolio </p>
        </div>

        <div className="role-card green">
          <h3>Application Review</h3>
          <p>Our experts rigorously review your data to shortlist the best </p>
        </div>

        <div className="role-card pink">
          <h3>Interview</h3>
          <p>An expert panel selects the best candidate </p>
        </div>
      </div>

      {/* ---------- TEXT HEADING ---------- */}
      <h2 className="roles-heading">Find Your Roles</h2>

      {/* ---------- TAG GRID ---------- */}
      <div className="roles-grid">
        {traits.map((item, index) => (
          <button
            key={index}
            className={`roles-tag ${active === index ? "active" : ""}`}
            onMouseEnter={() => setActive(index)}
            onMouseLeave={() => setActive(null)}
          >
            {item}
          </button>
        ))}
      </div>
    </section>
  );
}
